import axios from "axios";
import { logout } from "./auth.action";
import { endpointApi } from "../../utils";
import { RAMBO_LIST_FAIL, RAMBO_LIST_REQUEST, RAMBO_LIST_SUCCESS, RAMBO_LIST_UPDATE } from "../constats/rambo.constant";

export const getRambos = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: RAMBO_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }rambos${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: RAMBO_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: RAMBO_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: RAMBO_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}

export const updateElementInList = (element) => async(dispatch) => {
    dispatch({
        type: RAMBO_LIST_UPDATE,
        payload: element
    })
}